export class EventItemAffCode {
  public constructor() {
    this.Id = 0;
    this.EventItemId = 0;
    this.AffCode = '';
  }
  public Id: number;
  public EventItemId: number;
  public AffCode: string;
}
